export default "__VITE_ASSET__ksJlV2Lz__"